import { createActions } from 'reduxsauce'

const { Types, Creators } = createActions({
  getPaymentsCouponProgress: ['pdn'],
  getPaymentsCouponProgressLoading: null,
  getPaymentsCouponProgressSuccess: ['res'],
  getPaymentsCouponProgressFailure: ['error'],

  applyPaymentPromoCode: ['promoCode', 'overrideOthers'],
  applyPaymentPromoCodeLoading: null,
  applyPaymentPromoCodeSuccess: ['res'],
  applyPaymentPromoCodeFailure: ['error'],

  getPaymentHistory: ['pdn','startDate', 'endDate' ],
  getPaymentHistoryLoading: null,
  getPaymentHistorySuccess: ['res'],
  getPaymentHistoryFailure: ['error'],

  cleanPaymentState: null

}, { prefix: 'PAYMENTS_' })

export const PaymentsTypes = Types

export default Creators
